<template>
  <div>
    <div class="inline-block min-w-full align-middle">
      <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
        <table class="min-w-full divide-y divide-gray-300">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">DNS server</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">TTL</th>
              <th scope="col" class="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">{{ hasVariants ? 'Variant' : 'Response' }}</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white">
            <tr v-for="item in props.items" :key="item.firstLine">
              <td class="py-2 pl-4 pr-3 text-sm sm:pl-6">
                <div class="h-10 flex items-center">
                  <div :class="item.iconShape === 'circle' ? 'h-6 w-6 rounded-full' : 'h-[1.125rem] w-6'" class="flex-shrink-0">
                    <img :class="item.iconShape === 'circle' ? 'h-6 w-6 rounded-full' : 'h-[1.125rem] w-6'" :src="item.iconSrc" :alt="item.iconAlt" :title="item.iconAlt" />
                  </div>
                  <div class="ml-4">
                    <div class="break-words font-medium text-gray-900">{{ item.firstLine }}</div>
                    <div class="break-all text-gray-500">{{ item.secondLine }}</div>
                  </div>
                </div>
              </td>
              <td class="break-words px-3 py-2 text-sm text-gray-500">
                <div class="text-gray-900"><Duration v-if="item.ttl" :seconds="item.ttl" /></div>
              </td>
              <td class="whitespace-nowrap px-3 py-2 text-lg text-gray-500 font-medium text-center">
                <CheckCircleIcon v-if="item.variant === true" class="h-6 w-6 text-green-500 mx-auto" aria-hidden="true" />
                <template v-else>
                  {{ item.variant }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { CheckCircleIcon } from '@heroicons/vue/20/solid';
import Duration from '@/components/micro/DurationComponent.vue';

export interface PropagationServerListItem {
  firstLine: string;
  secondLine: string;
  ttl: number | null;
  // null = not yet checked; true = only one variant; string = multiple variants
  variant: string | true | null;
  iconSrc: string;
  iconAlt: string;
  iconShape: 'circle' | '4x3';
}

const props = defineProps({
  items: {
    type: Array as PropType<Array<PropagationServerListItem>>,
    required: true,
  },
});

const hasVariants = computed(() => props.items.some((item) => item.variant !== true && item.variant !== null));
</script>
